export default __webpack_public_path__ + "static/media/qp-logo.2a0a8dbe.png";